export const isFr = () => (typeof window !== 'undefined' && String(window.locale || 'en').toLowerCase().startsWith('fr'));

export const getDealRoomBrandedName = (company) => {
  if (!company) return isFr() ? 'Salle de transaction' : 'Deal Room';
  return isFr()
    ? (company.deal_room_branded_name_fr || company.deal_room_branded_name || 'Salle de transaction')
    : (company.deal_room_branded_name || 'Deal Room');
};

export const getDealRoomSingleWord = (company) => {
  if (!company) return isFr() ? 'Salle de transaction' : 'Deal Room';
  return isFr()
    ? (company.deal_room_single_word_fr || company.deal_room_single_word || 'Salle de transaction')
    : (company.deal_room_single_word || 'Deal Room');
};
